import MuiSlider from "@mui/material/Slider";
import { createTheme } from "@mui/material/styles";
import React, { useContext, useEffect } from "react";
import styled, { ThemeProvider } from "styled-components";

import { InteractionTypeEnum, Stem } from "@examspark/types";

import Mark from "../../common/Mark";
import QuestionContext from "../../QuestionContext";
import Prompt from "../shared/Prompt";
interface MarkProps {
  mark?: "correct" | "incorrect";
}

const Styled = styled.div<MarkProps>`
  margin: 1rem 0;
  max-width: 50rem;
  position: relative;
  padding: 2rem 1.5rem;
  border-top: solid 3px transparent;

  ${(props) => {
    if (props.mark === "correct") {
      return `
      background-color: #e4f3e4;
      border-top: solid 3px #9cb39c;
      `;
    }
    if (props.mark === "incorrect") {
      return `
      background-color: #f3e2e2;
      border-top: solid 3px #b32e2b;
      `;
    }
  }}

  .markup {
    position: absolute;
    top: -11px;
    right: -8px;
  }
`;

export interface SliderProps {
  data: Stem.Stem;
}

const muiDefaultTheme = createTheme();

const Slider: React.FC<React.PropsWithChildren<SliderProps>> = (props) => {
  const [player, dispatchPlayer] = useContext(QuestionContext);

  // Reveal Key
  useEffect(() => {
    if (player.revealKey) {
      dispatchPlayer({
        type: "RESPONSE",
        data: {
          id: props.data.id,
          score: true,
          response: {
            value: Number(props.data.scoring?.slider?.[0]?.value),
          },
        },
      });
    }
  }, [player.revealKey]);

  // Score responses
  let mark: "incorrect" | "correct" | undefined;
  if (player.scoreResponses) {
    mark = "incorrect";

    if (
      Number(props?.data?.scoring?.slider?.[0]?.value) ===
      player.response?.[props.data.id]?.value
    ) {
      mark = "correct";
    }
  }

  const stem = props.data;
  if (stem.interactionType !== InteractionTypeEnum.Slider) return <></>;

  return (
    <>
      <Prompt data={props.data.content.prompt} />
      <Styled mark={mark}>
        {mark && <Mark type={mark} />}
        {/* Mui defaults */}
        <ThemeProvider theme={muiDefaultTheme as any}>
          <MuiSlider
            // aria-label="Temperature"
            // getAriaValueText={() => "30"}
            defaultValue={Number(stem.config.slider.min) || 0}
            value={player.response?.[props.data.id]?.value || 0}
            onChange={(e, newValue) => {
              dispatchPlayer({
                type: "RESPONSE",
                data: {
                  id: props.data.id,
                  response: {
                    value: newValue,
                  },
                },
              });
            }}
            valueLabelDisplay="auto"
            min={Number(stem.config.slider.min) || 0}
            max={Number(stem.config.slider.max) || 10}
            step={Number(stem.config.slider.step) || 1}
            marks
          />
        </ThemeProvider>
      </Styled>
    </>
  );
};

export default Slider;
